import React from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from "react-icons/io";
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from "react-slick";
import 'animate.css';

function CustomGallery({myGallery}) {

    //console.log(myGallery);

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        myGallery ?
            <section className="mb-16 md:mb-32">
                <div className="container mx-auto text-center mt-12">
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2 className="text-3xl text-center font-bold uppercase mb-9 
                        lg:text-[42px] lg:mb-12 xl:text-[52px]">{myGallery.gallery_title}</h2>
                    </ScrollAnimation>
                </div>
                <div className="grid grid-cols-2 lg:grid-cols-4">
                    {
                        myGallery.gallery_item.map((item, index) => (

                            <a href="#" onClick={openModal} className="overflow-hidden" key={index}>
                                <img src={item} alt="img" className="hover:scale-110 transition duration-300"/>
                            </a>

                        ))
                    }
                </div>

                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false}>

                    <button onClick={closeModal} className="absolute top-0 left-0 right-0 z-[999]"><IoMdCloseCircleOutline className="text-red-800 text-4xl z-60" /></button>
                    <Slider {...settings}>
                        {
                            myGallery.gallery_item.map((item, index) => (

                                <img src={item} alt="img" key={index} />

                            ))
                        }
                    </Slider>

                </Modal>

            </section> : ''
    )

}

export default CustomGallery;
